import {
  FETCH_FEATURED_REQUEST,
  RECEIVE_FEATURED,
  RECEIVE_FEATURED_ERROR,
} from 'redux/constants/ActionTypes'

import { createApiAction } from './ApiActions'

// API actions
export const fetchFeatured = (currentLocale) => {
  return createApiAction({
    endpoint: `/${currentLocale}/projects?featured=true`,
    types: [FETCH_FEATURED_REQUEST, RECEIVE_FEATURED, RECEIVE_FEATURED_ERROR],
    mapIds: true,
    currentLocale,
  })
}
